(() => {
  const sectionSelector = '.page-with-toc[data-section-id]';

  function getHeaderHeight() {
    const headerSelectors = [
      '.shopify-section-header-sticky',
      '.header-wrapper',
      'header.header',
      'header[role="banner"]',
      'header'
    ];
    const el = headerSelectors.map(s => document.querySelector(s)).find(Boolean);
    if (!el) return 0;
    const cs = getComputedStyle(el);
    const isSticky = cs.position === 'sticky' || cs.position === 'fixed';
    return isSticky ? el.offsetHeight : 0;
  }

  function updateOffsets() {
    const h = getHeaderHeight();
    const offset = (h || 80) + 16;
    document.documentElement.style.setProperty('--anchor-offset', offset + 'px');
    document.documentElement.style.setProperty('--toc-sticky-top', offset + 'px');
  }

  function initSection(root) {
    const content = root.querySelector('[data-toc-scan]');
    const list = root.querySelector('[data-toc-list]');
    if (!content || !list) return;

    const selector = root.getAttribute('data-heading-selector') || 'h2';
    const headings = Array.from(content.querySelectorAll(selector)).filter(h => h.textContent.trim().length);

    if (!headings.length) {
      const sb = root.querySelector('.page-with-toc__sidebar');
      if (sb) sb.style.display = 'none';
      return;
    }

    const slugify = (str) => str.toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
      .replace(/[^a-z0-9\s-]/g,'').trim().replace(/\s+/g,'-').replace(/-+/g,'-');

    const used = new Set();
    headings.forEach(h => {
      if (!h.id) {
        let base = slugify(h.textContent);
        let id = base || 'abschnitt';
        let i = 2;
        while (used.has(id) || document.getElementById(id)) id = `${base}-${i++}`;
        h.id = id; used.add(id);
      }
    });

    list.innerHTML = '';
    headings.forEach(h => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = h.textContent.trim();
      a.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementById(h.id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', a.href);
      });
      li.appendChild(a);
      list.appendChild(li);
    });

    const links = Array.from(list.querySelectorAll('a'));
    const map = new Map(headings.map(h => [h.id, links.find(a => a.hash === `#${h.id}`)]));

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const link = map.get(entry.target.id);
        if (!link) return;
        if (entry.isIntersecting) {
          links.forEach(l => l.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'true');
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px', threshold: 0.01 });

    headings.forEach(h => io.observe(h));
  }

  function initAll() {
    updateOffsets();
    document.querySelectorAll(sectionSelector).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  window.addEventListener('resize', updateOffsets);
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('load', () => {
    if (location.hash.length > 1) {
      const target = document.getElementById(location.hash.slice(1));
      if (target) target.scrollIntoView({ block: 'start' });
    }
  });
})();
